import React, { useEffect, useState } from 'react'
import { ISpace } from '@api'
import { DateUtil } from '@utils'

import css from './BookingsAccordion.module.scss'
import { Avatar, Flex, Icon } from '@ui'
import cx from 'classnames'
import EmployeeStartEndDate from 'components/AdminFloorPlan/Card/EmployeeStartEndDate'
import { UseFloorHook } from '@providers/mapProvider'
import { Button, Divider } from '@runeffective/evo-design-system'
const BookingsAccordion = ({ spaces, floor }: { spaces: ISpace[]; floor: UseFloorHook }) => {
  const [active, setActive] = useState<string | null>(null)
  const [showAllFlag, setShowAllFlag] = useState(false)

  return (
    <div style={{ height: '100%', overflowY: 'auto' }}>
      <Button
        style={{ marginLeft: '0px' }}
        aria-label="show-all-bookings"
        onClick={() => {
          setShowAllFlag((prevFlag) => !prevFlag)
          setActive(null)
        }}
        size="default"
        startIcon={
          <Icon
            light
            name={showAllFlag ? 'chevron-down' : 'angle-right'}
            className={cx('fa-light', css.angleIcon)}
          />
        }
        layout="borderless">
        Show All
      </Button>
      <div className={css.accordionTitle}></div>

      {Object.keys(spaces).map((key) => {
        const space = spaces[key as unknown as number]
        const timezone = space.floor?.building?.timezone
        const toolbar =
          space && space.bookings && space.bookings.length > 1 ? (
            <div key={space.id} className={css.toolbar}>
              <Icon
                light
                name={showAllFlag || active === space.id ? 'chevron-down' : 'angle-right'}
                className={cx('fa-light', css.angleIcon)}
              />
              <span
                className={
                  css.accordionTitle
                }>{`${space.usageType?.displayName}: ${space.externalId}`}</span>
              <div className={css.accordionBookingTitle}>{space.bookings.length} Bookings</div>
            </div>
          ) : (
            <div
              key={space.id}
              className={css.toolbar}
              onClick={() => floor?.spaceLocate?.({ floorId: space.floor.id, spaceId: space.id })}>
              <span
                className={
                  css.accordionTitle
                }>{`${space.usageType?.displayName}: ${space.externalId}`}</span>
            </div>
          )

        const content = (
          <div
            key={space.id}
            onClick={() => floor?.spaceLocate?.({ floorId: space.floor.id, spaceId: space.id })}>
            <div className={css.employeeCard}>
              {space.bookings?.map((booking) => (
                <div key={`${space.id}-${booking.id}`} className={css.bookingItem}>
                  <div style={{ marginRight: 16 }}>
                    <Avatar
                      size={Avatar.Size.XS}
                      name={booking.employee.name}
                      assets={booking.employee.assets}
                    />
                  </div>

                  <div className={css.text}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div className={`${css.large} ${css.ellipsis}`}>{booking.employee.name}</div>
                      <div className={css.small}>
                        <EmployeeStartEndDate
                          dateFormat="MMM dd, h:mm a"
                          startDate={DateUtil.tz(booking.startDate, timezone)}
                          endDate={DateUtil.tz(booking.endDate, timezone)}
                          showTooltip={false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )

        const data = [{ toolbar: toolbar, content: content, id: space.id }]

        return space && space.bookings && space.bookings.length === 1 ? (
          <div key={space.id}>
            {toolbar}
            {content}
            <Divider type="horizontal" />
          </div>
        ) : (
          space && space.bookings && space.bookings.length > 1 && (
            <>
              <Flex direction="column">
                {data?.map((d) => {
                  return (
                    <div key={d.id}>
                      <div
                        onClick={() => {
                          setActive((prevActive) => (prevActive === d.id ? null : d.id))
                          setShowAllFlag(false)
                        }}>
                        {d.toolbar}
                      </div>
                      {(showAllFlag || active === d.id) && <div>{d.content}</div>}
                    </div>
                  )
                })}
              </Flex>
              <Divider type="horizontal" />
            </>
          )
        )
      })}
    </div>
  )
}

export default BookingsAccordion
